import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../services/apiClient";

// Contexto de Autenticación
const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(localStorage.getItem("authToken"));
    const [userProfile, setUserProfile] = useState(null); // Estado para el perfil
    const [loadingProfile, setLoadingProfile] = useState(false); // Estado de carga
    const navigate = useNavigate();

    // Función para obtener el perfil del backend
    const fetchUserProfile = async (authToken) => {
        try {
            setLoadingProfile(true);
            const response = await apiClient.get("/user/profile");
            const data = response.data;
            
            // Mapear los campos del backend a los esperados en el frontend
            setUserProfile({
                name: `${data.first_name} ${data.last_name}`, // Combinar nombre y apellido
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                avatar: data.avatar || null, // Usar avatar si está disponible, o null
                country: data.country,
                phone: data.phone,
                description: data.description,
            });
        } catch (error) {
            console.error("Error fetching profile:", error);
            setUserProfile(null);
            // El interceptor de apiClient ya maneja el logout automáticamente
        } finally {
            setLoadingProfile(false);
        }
    };

    /*
    useEffect(() => {
        const interval = setInterval(() => {
            if (token && isTokenExpired(token)) {
                logout(); // Desloguea si el token vence
            }
        }, 5000); // Verifica cada 5 segundos

        return () => clearInterval(interval);
    }, [token]);


    useEffect(() => {
        const storedToken = localStorage.getItem("authToken");
        if (storedToken !== token) {
            setToken(storedToken);
        }
    }, [token]);



    useEffect(() => {
        // Validar el token al iniciar la app
        if (!token || isTokenExpired(token)) {
            setToken(null);
            //navigate("/login");
        }
    }, [token, navigate]);

     */

    useEffect(() => {
        const handleStorageChange = () => {
            const storedToken = localStorage.getItem("authToken");
            setToken(storedToken); //Sincroniza el estado con localStorage
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    // Obtener el perfil cuando el token cambie
    useEffect(() => {
        if (token && !isTokenExpired(token)) {
            fetchUserProfile(token); // Llamar al backend si hay un token válido
        } else {
            setUserProfile(null); // Limpiar el perfil si no hay token
        }
    }, [token]);

    const login = (newToken) => {
        localStorage.setItem("authToken", newToken);
        setToken(newToken);
    };

    const logout = () => {
        localStorage.removeItem("authToken");
        setToken(null);
        navigate("/login");
    };

    const tokenExists = () => token && !isTokenExpired(token);

    return (
        <AuthContext.Provider
            value={{ token, userProfile, loadingProfile, login, logout, tokenExists }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}

// Helper para verificar si el token está vencido
function isTokenExpired(token) {
    try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000 < Date.now(); // Comprueba la expiración
    } catch (e) {
        return true; // Si no es un JWT válido, lo considera vencido
    }
}
